export function fileSelectionKey(file: File): string {
  const webkit = (file as File & { webkitRelativePath?: string }).webkitRelativePath
  const path = webkit && webkit.length > 0 ? webkit : file.name
  return `${path}|${file.size}|${file.lastModified}`
}

/** Stable key for a file list — used to avoid re-parsing the same selection in embedded upload dialogs. */
export function fileSelectionListKey(files: File[]): string {
  return files.map(fileSelectionKey).sort().join('\n')
}

/** Merge file picks, deduping by relative path / name + size + mtime. */
export function mergeFileSelections(existing: File[], added: File[]): File[] {
  const map = new Map<string, File>()
  for (const file of [...existing, ...added]) {
    map.set(fileSelectionKey(file), file)
  }
  return Array.from(map.values())
}

export async function readTxtFileContents(
  files: File[]
): Promise<Array<{ file: File; text: string }>> {
  const results = await Promise.all(
    files.map(
      (file) =>
        new Promise<{ file: File; text: string }>((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            resolve({
              file,
              text: typeof reader.result === 'string' ? reader.result : ''
            })
          }
          reader.onerror = () => reject(reader.error ?? new Error(`Failed to read ${file.name}`))
          reader.readAsText(file)
        })
    )
  )
  return results
}
